export const SITE_ORIGIN = 'https://silverperfumes.thevinculum.org.in';
export const SITE_NAME = 'Silver Perfumes';
export const SITE_EMAIL = 'silverperfumes108@gmail.com';
export const SITE_PHONE_DISPLAY = '+91 9998863360';
export const SITE_PHONE_TEL = '+919998863360';
export const SITE_WHATSAPP = '919998863360';
export const LOGO_SRC = `${process.env.PUBLIC_URL}/logo.png`;
export const LOGO_ABSOLUTE_URL = `${SITE_ORIGIN}${process.env.PUBLIC_URL || ''}/logo.png`;
